import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/all', label: '产品中心' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-xl font-bold tracking-tight transition-colors duration-300 whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
          >
            baoyu
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap hover:text-primary-500 ${
                  location.pathname === link.path
                    ? scrolled || !isHome
                      ? 'text-primary-500'
                      : 'text-white'
                    : scrolled || !isHome
                      ? 'text-foreground-700'
                      : 'text-white/80'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium transition-all duration-200 whitespace-nowrap hover:bg-primary-600 cursor-pointer"
            >
              联系我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-80' : 'max-h-0'
        } ${scrolled || !isHome ? 'bg-background-50' : 'bg-black/80 backdrop-blur-md'}`}
      >
        <div className="px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-2 text-sm font-medium whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className="block w-full text-center px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </div>
    </nav>
  );
}